const extrapolateInterest = function( interestid, interestsSet=[] ) {
    for( var j = 0; j < interestsSet.length; j++ ) {
        if( interestsSet[j].interestid == interestid ) {
            return interestsSet[j].interest;
        }
    }
    return '';
};

const camelCase = ( string ) => {
    string = string ? string : '';
    return string.toLowerCase().replace(/\s+/g, '');
};

const validateWebUrl = ( url ) => {
    var urlRegEx = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b(?:[-a-zA-Z0-9@:%_\+.~#?&\/=]*)/i;
    return urlRegEx.test( url );
};

const validateSlug = ( slug ) => {
    var reg = /[\<\>\#\%\"\{\}\|\^\[\]\`\;\/\?\:\@\&\=\+\$\,\s]/;
    return !reg.test( slug );
};

const testReservedSlugs = ( slug ) => {
    var reg = /^(admin|app|phantom|puppeteer|sitemap|extension|embed|l|tv|cheech|v|b|a|product|list|class|article)$/i;
    return reg.test( slug );
};

const convertSlug = ( slug ) => {
    slug = slug ? slug : '';
    var reg = /[\<\>\#\%\"\{\}\|\^\[\]\`\;\/\?\:\@\&\=\+\$\,\s]/g;
    return slug.replace( reg, '' );
};

const addTransferProtocol = ( url ) => {
    //check to see if url starts with http
    if( !(/^https?:\/\//).test( url ) ) {
        //add http://
        var tempUrl = 'http://' + url;
        if( validateWebUrl( tempUrl ) ) {
            return tempUrl;
        }
    }
    return url;
};

const validatePassword = ( password ) => {
    var passRegEx = /^(?=.*[0-9])(?=.*[a-zA-Z])(.{8,})$/;
    return passRegEx.test( password );
};

export const validateEmailAddress = ( value ) => {
    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test( value );
};

export const formatNumberToString = ( _number='', _sep=',' ) => {
    _number = _number.replace(new RegExp('^(\\d{' + (_number.length%3? _number.length%3:0) + '})(\\d{3})', 'g'), '$1 $2').replace(/(\d{3})+?/gi, '$1 ').trim();
    _number = _number.replace(/\s/g, _sep);
    return _number;
};

const fixCurrency = ( price ) => {
    price = price ? price : '0.00';
    var priceTest = /([\d\.,]+)/.exec( price );
    //remove any non-numeric values
    price = !!priceTest ? priceTest[ 1 ] : price;
    //replace non-American comma
    price = price.replace( /,(\d\d?)$/, '.$1' );
    //fix any responses that only go to one decimal place
    price = price.replace( /(\.\d)$/, '$1'+'0' );
    //fix any response that doesn't include a decimal places
    price += /^[^\.]+$/.test( price ) ? '.00' : '';
    return price;
};

const dliRx = /^https?:\/\/(?:desirelistimages\..*amazonaws.com|dahcy03mzpux1.cloudfront.net)/i;
export const convertImage = ( image, size='' ) => {
    var ret = image;
    if( dliRx.test( image ) ) {
        var slashLoc = image.lastIndexOf( '/' );
        ret = image.substring( 0, slashLoc ).concat( size, image.substring( slashLoc ) );
    }
    return ret;
};

export const userCanList = ( user={} ) => {
    return /(creator)/i.test( user.usertype );
};

export const extractHostname = ( url ) => {
    var ret = url;
    if( window.URL ) {
        var parsedUrl = new URL( url );
        ret = parsedUrl.hostname;
    } else {
        return url.replace( /^https?:\/\//, '' ).replace( /[\/?].*/, '' );
    }
    return ret;
};

export const deriveListSlug = ( list, canEdit=false ) => {
    if( canEdit ) {
        return `/app/my-lists/${ list.listid }/`;
    }
    return `/${ list.author.slug }/${ list.slug }/`;
};

export const copyToClipboard = ( textarea ) => {
    var msg = '';
    try {
        if ( navigator.userAgent.match( /ipad|ipod|iphone/i ) ) {
            var range = document.createRange();
            range.selectNodeContents( textarea );

            var s = window.getSelection();
            s.removeAllRanges();
            s.addRange( range );

            textarea.setSelectionRange(0, 999999);
        } else {
            textarea.select();
        }
        var successful = document.execCommand('copy');
        msg = successful ? 'Copied' : 'Failed to Copy';
    } catch (err) {
        msg = 'Failed to Copy';
    }
    textarea.blur();
    return msg;
};

export const saveOrphans = ( text='' ) => {
    var words = text.split( ' ' );
    var response = '';
    if( words.length > 3 ) {
        let finalWord = words.pop();
        response = words.join( ' ' );
        response += '\u00A0' + finalWord;
    } else {
        response = text;
    }
    return response;
};

export const encodeForURI = ( text ) => {
    if(typeof text !== 'undefined' && text !== null) {
        return ( encodeURIComponent( text.trim().replace( '%', '' ).replace( '\/', '\\' ).replace( /\s+/g, '-' ) ) );
    }
};

export const tdcDomainMatch = () => {
    let homeLink = '//thedesirecompany.com';
    if( !( window && window.location ) ) {
        return homeLink;
    }

    switch ( window.location.hostname ) {
        case 'localhost':
            homeLink = 'http://localhost:3000';
            break;
        case 'cms.dev.thedesirecompany.com':
            homeLink = 'https://site.dev.thedesirecompany.com';
            break;
        case 'cms.staging.thedesirecompany.com':
            homeLink = 'https://site.staging.thedesirecompany.com';
            break;
        case 'cms.prod.thedesirecompany.com':
            homeLink = 'https://thedesirecompany.com';
            break;
        default:
            homeLink = 'https://thedesirecompany.com';
    }
    return homeLink;
};

export {
    camelCase,
    validateWebUrl,
    addTransferProtocol,
    validatePassword,
    validateSlug,
    convertSlug,
    testReservedSlugs,
    extrapolateInterest,
    fixCurrency,
};
